import LucaFanitinCooking from "../../../assets/chef_luca_preparing_service.jpg"


const ExperienceSection = ({t}) => {
    const { experience = {} } = t
    return (
        <section className="py-12 bg-white mx-auto">
            <div className="container mx-auto px-4 max-w-[1200px]">
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Left Column */}
                    <div className="md:w-1/2 relative">
                        <div className="relative">
                            <img
                                src={LucaFanitinCooking}
                                alt="Chef decorating carrots"
                                className="w-[100%] h-auto"
                            />
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="md:w-1/2 flex flex-col justify-center pl-10">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{experience?.title}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px] ">{experience?.subTitle}</h2>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{experience?.description}</p>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px] ">{experience?.subTitle1}</h2>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{experience?.description1}</p>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px] ">{experience?.subTitle2}</h2>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{experience?.description2}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ExperienceSection;
